<template>
  <div class="tuolele-main-box set-combo">
    <div class="tuolele-main-search">
      <el-row type="flex" justify="space-between">
        <el-form :inline="true" :model="search">
          <el-form-item label="店铺名称">
            <el-input
              v-model="search.shop_name"
              clearable
              placeholder="请输入店铺名称"
            />
          </el-form-item>
          <el-form-item label="分组名称">
            <el-input
              v-model="search.team_name"
              clearable
              placeholder="请输入分组名称"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="el-button-confirm"
              @click="getList"
            >查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
    </div>
    <div class="tuolele-main-content">
      <el-button
        type="primary"
        style="margin-bottom: 20px;"
        @click="setMuliteCombo()"
      >配置分组</el-button>
      <el-table ref="table" :data="tableData" border stripe @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55"
        />
        <el-table-column prop="name" label="店铺" />
        <el-table-column
          prop="item_team_text"
          label="套餐分组"
        />
        <el-table-column prop="item_count" label="套餐数量" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="setCombo(scope.row)"
            >配置分组</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="配置分组" :visible.sync="dialogVisible" width="40%">
        <el-checkbox
          v-model="checkAll"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
        >全选</el-checkbox>
        <div style="margin: 15px 0;" />
        <el-checkbox-group
          v-model="checkedGroup"
          @change="handlecheckedGroupChange"
        >
          <el-checkbox
            v-for="item in groupList"
            :key="item.team_id"
            :label="item.team_id"
            name="checkedGroup"
          >
            {{ item.team_name }}</el-checkbox>
        </el-checkbox-group>
        <div style="text-align:right;margin-top:20px;">
          <el-button type="primary" @click="submit">确认</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StoreSetting',
  data() {
    return {
      dialogVisible: false,
      search: {
        shop_name: '',
        team_name: ''
      },
      comboCheckLists: [],
      tableData: [],
      checkAll: false,
      checkedGroup: [],
      groupList: [],
      team_id: [],
      isIndeterminate: true
    }
  },
  mounted() {
    this.getComboGroup()
    this.getList()
  },
  methods: {
    getComboGroup() {
      this.$http.getItemTeamList(this.search).then(res => {
        this.groupList = res.data.list
        this.team_id = this.groupList.map(e => {
          return e.team_id
        })
      })
    },
    getList() {
      this.$http.getShopItemList(this.search).then(res => {
        this.tableData = res.data
      })
    },
    setCombo(row) {
      this.dialogVisible = true
      this.shop_id = row.id
      this.checkedGroup = row.item_team_id ? row.item_team_id.split(',') : []
    },
    setMuliteCombo() {
      if (this.comboCheckLists.length === 0) {
        this.$message({
          type: 'warning',
          message: '请至少选择一个店铺'
        })
        return
      }
      this.shop_id = this.comboCheckLists.map(e => {
        return e.id
      }).join(',')
      this.checkedGroup = []
      this.dialogVisible = true
    },
    handleSelectionChange(row) {
      this.comboCheckLists = row
    },
    handleCheckAllChange(val) {
      this.checkedGroup = val ? this.team_id : []
      this.isIndeterminate = false
    },
    handlecheckedGroupChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.team_id.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.team_id.length
    },
    submit() {
      this.$http
        .assignShopItem({
          shop_id: this.shop_id,
          item_team_id: this.checkedGroup.join(',')
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: '配置分组成功'
          })
          this.dialogVisible = false
          this.getList()
        })
    }
  }
}
</script>
<style lang="scss">
.set-combo {
  .self-table {
    margin-top: 0 !important;
  }
  .el-form-item__label {
    font-size: 16px;
    color: #333;
  }
  .el-form-item__content {
    margin: 0 20px 0 12px;
  }
  .el-button.el-button-confirm {
    width: 80px !important;
  }
}
</style>
